import React, { useEffect, useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

const GeneralButtonWithText = (props: UIProperties<GeneralButtonWithTextConfig>) => {
	const [isOver, setIsOver] = useState(false);
	useEffect(() => {

	}, [isOver])

	const customStyles = () => {
		var r = props.parameters.isDisabled ? {
			...props.parameters.customMainStyle,
			...props.parameters.customDisabledMainStyle
		} : {
			...props.parameters.customMainStyle
		};

		return r
	}
	var onMouseUp = () => {
		console.warn('mouseup');
		if(!props.parameters.highlightOnHover) {
			setIsOver(false);
		}
	}

	var onMouseDown = () => {
		console.warn('mousedown');
		if(props.parameters.onPressAndHold && !props.parameters.isDisabled) {
			props.parameters.onPressAndHold();
		}

		if(!props.parameters.highlightOnHover) {
			setIsOver(true);
		}
	}

	var onMouseEnter = () => {
		console.warn('mouseenter');
		if(props.parameters.onMouseOver && !props.parameters.isDisabled) {
			props.parameters.onMouseOver();
		}
		if(props.parameters.highlightOnHover) {
			setIsOver(true);
		}
	}

	var onMouseOut = () => {
		console.warn('mouseout');

		if(props.parameters.onMouseOut && !props.parameters.isDisabled) {
			props.parameters.onMouseOut();
		}
		setIsOver(false);
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			touchAction: 'none',
			width: props.parameters.srcIdle && props.parameters.srcHighlight ? props.parameters.width : 'auto',
            ...customStyles()
		}}>
			<button id={props.parameters.id} aria-label={props.parameters.ariaLbl} tabIndex={props.parameters.ignoreTabbing ? -1 : 0} className="pointer" disabled={props.parameters.isDisabled} style={{
				position: 'relative',
				background: 'transparent',
				touchAction: 'none',
				pointerEvents: 'all',
				...props.parameters.customButtonStyle
			}} onPointerDown={(event: any) => {
				console.warn('onPointerDown');
				onMouseDown();
				event.target.releasePointerCapture(event.pointerId);
			}}
			onPointerUp={(event: any) => {
				console.warn('onPointerUp');
				onMouseUp();
			}}
			onPointerEnter={(event: any) => {
				console.warn('onPointerEnter');
				onMouseEnter();
			}}
			onPointerLeave={(event: any) => {
				console.warn('onPointerLeave');
				onMouseOut();
			}}
			onMouseEnter={() => {
				onMouseEnter();
			}} onMouseDown={() => {
				onMouseDown();
			}} onMouseUp={() => {
				onMouseUp();
			}} onMouseOut={() => {
				onMouseOut();
			}}
			aria-disabled={props.parameters.isDisabled}
			onKeyUp={(evt: any) => {
				if(props.parameters.isDisabled) {
					return
				}
				if(props.parameters.onKeyUp && !props.parameters.isDisabled) {
					props.parameters.onKeyUp(evt);
				}
			}}
			onClick={() => {
				if(props.parameters.isDisabled) {
					return
				}
				if(props.parameters.onClicked && !props.parameters.isDisabled) {
					props.parameters.onClicked();
				}
			}}>
				{props.parameters.srcIdle ? <img style={{...props.parameters.customImgStyle,
					pointerEvents: 'none',
					position: 'relative'
				}} src={props.parameters.srcIdle} /> : (null)}
				
				{(isOver && props.parameters.srcHighlight) || props.parameters.shouldLeaveOn ? (<img style={{...props.parameters.customImgStyle,
					position: 'absolute',
					top: '0',
					left: '0',
					height: '100%',
					pointerEvents: 'none'
				}} src={props.parameters.srcHighlight ? props.parameters.srcHighlight : "./assets/images/general/buttons/button_hover.png"}  />) : (<div></div>)}

				{props.parameters.isDisabled && props.parameters.srcDisabled ? (<img style={{...props.parameters.customImgStyle,
					position: 'absolute',
					top: '0',
					left: '0',
					height: '100%',
					pointerEvents: 'none'
				}} src={props.parameters.srcDisabled}  />) : (<div></div>)}

				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '100%',
					color: 'white',
					pointerEvents: 'none',
                    ...props.parameters.customTextStyle
				}}>{props.parameters.text}</p>
			</button>
		</div>
	);

};

export interface GeneralButtonWithTextConfig extends BaseConfig{
	top: string;
	left: string;
	ignoreTabbing?: boolean;
	srcIdle?: string;
	srcHighlight?: string;
	isDisabled?: boolean;
	srcDisabled?: string;
	text: string;
	width: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	customButtonStyle?: any;
	customImgStyle?: any;
	customTextStyle?: any;
	customMainStyle?: any;
	customDisabledMainStyle?: any;
	ariaLbl?: string;
	id?: string;
	onClicked: () => void;
	onKeyUp?: (evt: any) => void;
	onPressAndHold?: () => void;
	onMouseOver?: () => void;
	onMouseOut?: () => void;
}

export default GeneralButtonWithText;